import vars from '../helpers';

function openMenu(container) {
	const $Content = $(container);

	const $menu = $('.menu');

	gsap.timeline().to($Content, {
		autoAlpha: 0,
		onComplete: () => {
			$Content.addClass('is-hidden');
		},
	});

	gsap.timeline().from($menu, {
		autoAlpha: 0,
		onStart: () => {
			$menu.removeClass('is-hidden');
		},
	});
}

function closeMenu($Content) {
	const $menu = $('.menu');

	gsap.timeline().to($Content, {
		opacity: 1,
		clearProps: true,
		onStart: () => {
			$Content.removeClass('is-hidden');
		},
	});

	gsap.timeline().to($menu, {
		autoAlpha: 0,
		clearProps: true,
		onComplete: () => {
			$menu.addClass('is-hidden');
		},
	});
}

export function menu(container) {
	const $header = $('.header');

	const $headerButton = $header.find('.header__button');

	$headerButton.on('click', (e) => {
		const $currentTarget = $(e.currentTarget);

		vars.$html.toggleClass('open-menu');

		$headerButton.toggleClass('is-active');

		if (!$currentTarget.hasClass('is-active')) {
			closeMenu(container);
		} else {
			openMenu(container);
		}
	});
}
